module.exports = __webpack_public_path__ + "static/media/open-eye.dd7a632c.svg";